import React from 'react'
import Backlog from './Backlog'
import InProgress from './InProgress'
import Issues from './Issues'
import Finished from './Finished'

function FlowChart() {
  return (
    <div>
      <div>
        <p className='text-lg font-semibold my-5'>Roles Needed</p>
        <div className='my-3 font-medium italic'>
            <p>Project Manager</p>
            <p>Legal Advisor</p>
            <p>Software Developer</p>
        </div>
      </div>

      <div className='my-10'>
      <p className='text-lg font-semibold'>Backlog:</p>
        <Backlog />
      </div>

      <div className='my-10'>
      <p className='text-lg font-semibold'>In-Progress:</p>
        <InProgress />
      </div>

      <div className='my-5'>
      <p className='text-lg font-semibold'>Issues:</p>
        <Issues />
      </div>

      <div className='my-5'>
      <p className='text-lg font-semibold'>Finished:</p>
        <Finished />
      </div>
    </div>
  )
}

export default FlowChart
